{
  "moreActions": "פעולות נוספות"
}
